import './conflict-result-panel.css'

const ConflictResultPanel = ({totalConflicts, solvedConflicts, notSolvedConflicts}) => {

    return(
        <div className="result-panel-container">
            <span>Total de conflitos:</span>
            <div className="conflicts-container">{totalConflicts}</div>
            <span>Resolvidos:</span>
            <div className="conflicts-container solved">{solvedConflicts}</div>
            <span>Pendentes:</span>
            <div className="conflicts-container not-solved">{notSolvedConflicts}</div>
        </div>
    )
}

export default ConflictResultPanel